import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  background-size: cover !important;
  background-color: ${props => props.theme.palette.charts.white};
  background-image: url('/assets/images/agilePruchaseBySector.svg');
  background-position: center;
  width: 100%;
`
export const Content = styled(({ margin, padding, ...props }) => <ContainerBase container {...props} />)`
  &.MuiContainer-root {
    padding: 64px 32px;
  }
  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding:  38px 40px;
    }
`

export const GridContainer = styled(({ margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 34px;
  line-height: 38px;
  letter-spacing: 0.2px;
  margin: 0;
  padding: 0 0 28px;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin: 0;
  padding: 0 0 28px;
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 14px;
  text-decoration: underline;
`
